import { CROSSCHECK_DISPLAYED_VERDICTS, type CheckAdjudication } from '@privisy/api-types';

/**
 * How a card presents AI Crosscheck (#1659). The one place the states are
 * defined; `unverified` and `skipped` are internal and show nothing.
 * - `confirmed`: agrees with the pattern check.
 * - `disputed-failed`: pattern check failed, the crosscheck found a quote, not applied.
 * - `disputed-passed`: pattern check passed, the crosscheck rejected it, not applied.
 * - `corrected-pass` / `corrected-fail`: enforce mode applied the crosscheck's verdict.
 */
export type CrosscheckState = 'confirmed' | 'disputed-failed' | 'disputed-passed' | 'corrected-pass' | 'corrected-fail';

export function crosscheckState(adjudication: CheckAdjudication | undefined): CrosscheckState | null {
  // The shared list the AI Crosscheck counts read too (#1658).
  if (!adjudication || !CROSSCHECK_DISPLAYED_VERDICTS.has(adjudication.verdict)) return null;
  switch (adjudication.verdict) {
    case 'confirmed':
      return 'confirmed';
    case 'upgraded':
      return adjudication.applied ? 'corrected-pass' : 'disputed-failed';
    case 'downgraded':
      return adjudication.applied ? 'corrected-fail' : 'disputed-passed';
    default:
      return null;
  }
}

export function isDisputed(state: CrosscheckState | null): state is 'disputed-failed' | 'disputed-passed' {
  return state === 'disputed-failed' || state === 'disputed-passed';
}
